export const transformBirthdate = (dateString) => {
  if (!dateString) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return dateString;

  const parts = dateString.split("/");
  if (parts.length === 3) {
    const [day, month, year] = parts;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
  return dateString;
};

export const mapGenderToOrinter = (gender) => {
  if (!gender) return "MALE";
  const g = gender.toUpperCase().trim();
  if (g === "F" || g === "FEMALE" || g === "FEMININO") return "FEMALE";
  return "MALE";
};

export const mapDocumentTypeToOrinter = (docType) => {
  if (!docType) return "CPF";
  const t = docType.toUpperCase().trim();
  if (t === "RG") return "RG";
  if (t === "PASSPORT" || t === "PASSAPORTE") return "PASSPORT";
  return "CPF";
};

export const calculateAge = (birthdate) => {
  if (!birthdate) return 30;
  let birthDate;
  if (/^\d{4}-\d{2}-\d{2}$/.test(birthdate)) {
    birthDate = new Date(birthdate);
  } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(birthdate)) {
    const [day, month, year] = birthdate.split("/");
    birthDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  } else {
    return 30;
  }
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
  return age;
};

export const buildCheckRateRequest = (roomSelected, quartos, searchState) => {
  const rooms = Array.isArray(roomSelected) ? roomSelected : [roomSelected];
  const firstRoom = rooms[0];

  const originalHotelAvail = firstRoom?.hotel?._originalData;

  if (!originalHotelAvail) {
    console.error("hotelMapper: _originalData not found on hotel");
    return {};
  }

  const allSelectedRooms = rooms.map((roomData) => {
    const roomKey = roomData?.key;
    const roomRefToken = roomData?.refToken;

    let originalRoom = null;
    if (originalHotelAvail.roomGroups) {
      for (const rg of originalHotelAvail.roomGroups) {
        const found = (rg.rooms || []).find((r) => r.key === roomKey);
        if (found) {
          originalRoom = found;
          break;
        }
      }
    }

    return originalRoom || { key: roomKey, refToken: roomRefToken };
  });

  const selectedRoomGroups = [{ rooms: allSelectedRooms }];

  const hotelAvail = {
    ...originalHotelAvail,
    roomGroups: selectedRoomGroups,
  };

  const occupancy = buildOccupancyForCheckRate(quartos, searchState);

  return {
    hotelAvails: [hotelAvail],
    occupancy,
  };
};

export const buildOccupancyForCheckRate = (quartos, searchState) => {
  if (!quartos || quartos.length === 0) {
    return [];
  }

  const sortedQuartos = [...quartos].sort((a, b) => a.quarto - b.quarto);

  return sortedQuartos.map((quarto, roomIndex) => {
    const apartment = searchState?.apartments?.[roomIndex] || {
      adults: searchState?.qtAdult || 1,
      seniors: 0,
      childsAge: searchState?.childAge || [],
    };

    const numExpectedAdults = (apartment.adults || 0) + (apartment.seniors || 0) || 1;
    const sortedHospedes = [...quarto.hospedes].sort(
      (a, b) => a.hospede - b.hospede,
    );

    const adults = [];
    const children = [];

    sortedHospedes.forEach((hospede, index) => {
      const isMain = roomIndex === 0 && index === 0;
      const guestData = {
        firstName: hospede.name || "",
        lastName: hospede.lastName || "",
        email: hospede.email || "",
        birth: transformBirthdate(hospede.birthdate),
        document: {
          number: hospede.documentId || "",
          type: mapDocumentTypeToOrinter(hospede.documentType),
        },
        age: calculateAge(hospede.birthdate),
        gender: mapGenderToOrinter(hospede.gender),
        isMain: isMain,
      };

      if (index < numExpectedAdults) {
        adults.push(guestData);
      } else {
        const childIndex = index - numExpectedAdults;
        const childrenAges = apartment.childsAge || apartment.childrenAges || [];
        if (childIndex < childrenAges.length) {
          guestData.age = childrenAges[childIndex];
        }
        children.push(guestData);
      }
    });

    return { adults, children };
  });
};

export const buildOrinterGuests = (quartos, searchState) => {
  const guests = [];
  let isFirstGuest = true;

  const sortedQuartos = [...quartos].sort((a, b) => a.quarto - b.quarto);

  sortedQuartos.forEach((quarto) => {
    const sortedHospedes = [...quarto.hospedes].sort(
      (a, b) => a.hospede - b.hospede,
    );

    sortedHospedes.forEach((hospede) => {
      const guest = {
        firstName: hospede.name || "",
        lastName: hospede.lastName || "",
        birthDate: transformBirthdate(hospede.birthdate),
        document: {
          type: mapDocumentTypeToOrinter(hospede.documentType),
          number: hospede.documentId || "",
        },
        gender: mapGenderToOrinter(hospede.gender),
        age: calculateAge(hospede.birthdate),
        isMain: isFirstGuest || hospede.main === true,
      };

      if (isFirstGuest || hospede.main) {
        if (hospede.email) guest.email = hospede.email;
        if (hospede.phone) guest.phone = hospede.phone;
      }

      guests.push(guest);
      isFirstGuest = false;
    });
  });

  return guests;
};
